export class EventTypeGroupConfigChange {
    constructor(
        eventTypeGroupConfigChangeId: number,
        eventTypeGroupId: number,
        from: Date | null,
        to: Date | null,
        mandatory: boolean | null,
        multiple: boolean | null,
        concurrent: boolean | null,
        ordered: boolean | null,
        requiredPreviousTypeId: number | null,
        requiredPreviousTypeIdForceNull: boolean,
        requiredPreviousSameTypeId: number | null,
        requiredPreviousSameTypeIdForceNull: boolean,
        notAfterEventTypeId: number | null,
        notAfterEventTypeIdForceNull: boolean,
        enabledFrom: Date | null,
        enabledFromForceNull: boolean,
        deleted: boolean | null
    ) {
        this.eventTypeGroupConfigChangeId = eventTypeGroupConfigChangeId;
        this.eventTypeGroupId = eventTypeGroupId;
        this.from = from;
        this.to = to;
        this.mandatory = mandatory;
        this.multiple = multiple;
        this.concurrent = concurrent;
        this.ordered = ordered;
        this.requiredPreviousTypeId = requiredPreviousTypeId;
        this.requiredPreviousTypeIdForceNull = requiredPreviousTypeIdForceNull;
        this.requiredPreviousSameTypeId = requiredPreviousSameTypeId;
        this.requiredPreviousSameTypeIdForceNull = requiredPreviousSameTypeIdForceNull;
        this.notAfterEventTypeId = notAfterEventTypeId;
        this.notAfterEventTypeIdForceNull = notAfterEventTypeIdForceNull;
        this.enabledFrom = enabledFrom;
        this.enabledFromForceNull = enabledFromForceNull;
        this.deleted = deleted;
    }
    eventTypeGroupConfigChangeId: number;
    eventTypeGroupId: number;
    from: Date | null;
    to: Date | null;
    mandatory: boolean | null;
    multiple: boolean | null;
    concurrent: boolean | null;
    ordered: boolean | null;
    requiredPreviousTypeId: number | null;
    requiredPreviousTypeIdForceNull: boolean;
    requiredPreviousSameTypeId: number | null;
    requiredPreviousSameTypeIdForceNull: boolean;
    notAfterEventTypeId: number | null;
    notAfterEventTypeIdForceNull: boolean;
    enabledFrom: Date | null;
    enabledFromForceNull: boolean;
    deleted: boolean | null;
}
